import styled from 'styled-components';
import colors from 'Styles/colors';

export const Wrapper = styled.div`
    background-color: ${colors.white};
    min-height: 93px;
    padding: 9px 21px 20px 21px;
`;

Wrapper.displayName = 'PlaceholderWrapper';

export const PlaceholderText = styled.span`
  font-size: 12.5px;
  line-height: 1.76;
  color: ${colors.blueGrey};
  background-color: ${colors.yellow1};
  cursor: pointer;
`;

PlaceholderText.displayName = 'PlaceholderText';
